import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import { ArticleSchema } from './Schema';

const DataCleansingPage = () => {
  return (
    <div>
      <SEO
        title="What Does Data Cleansing Mean? - Lloyd James Data Consultancy"
        description="Learn about data cleansing processes, why data cleaning is important, and how Lloyd James Data Consultancy helps improve data quality and accuracy for better business outcomes."
        keywords="data cleansing, data cleaning, CRM data cleaning, customer data cleansing, data quality, Lloyd James Data Consultancy"
        canonical="/data-cleansing"
        type="article"
      />
      <ArticleSchema
        headline="What does data cleansing mean?"
        description="Data cleansing is the process of detecting and then removing or altering any data which appears to be corrupt or inaccurate in a database."
        author="Lloyd James Data Consultancy"
        datePublished="2024-01-01"
        image="/images/Lloyd-James-Data-Cleansing-.webp"
        url="/data-cleansing"
      />
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/Lloyd-James-Data-Cleansing-.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              What does data cleansing mean?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-xl font-semibold text-gray-900 mb-6">
                    In today's blog, we will be talking all things data cleansing<em>. </em>Data is only ever data, unless it's high quality, accurate and brought to life in the right way. Continue reading this article to gain an understanding of the services and processes of data cleansing.
                  </p>

                  <p className="text-2xl font-semibold text-gray-900 mb-4">
                    What is data cleansing?
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Data cleansing is the process of detecting and then removing or altering any data which appears to be corrupt or inaccurate in a database.
                  </p>

                  <p className="text-2xl font-semibold text-gray-900 mb-4">
                    The data cleaning process is as follows:
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Identifying duplicate sets of data and removing them from the dataset.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Amending structural errors e.g., spelling mistakes.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Removing unrequired sets of data.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Handle missing data – there are various data cleansing techniques for this.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Authenticate the data to avoid future mistakes/errors which can appear down the line.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Here at Lloyd James Data Consultancy, we're here to redefine consumer data lists to deliver a full-service data consultancy that's tailored precisely to your objectives. To find out more about how we redefine our data <Link to="/data-consultancy" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>click here.</Link>
                  </p>

                  <p className="text-2xl font-semibold text-gray-900 mb-4">
                    Why is data cleaning important?
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    It is important to ensure that customer data is regularly updated and efficiently checked to avoid affecting a company's reputation. CRM data cleaning, also known as customer data cleansing, is beneficial as it can form new business prospects whilst also saving time and money. The purpose of data cleansing services is to ensure data is kept updated, whilst also understanding ways to improve the quality of data.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Lloyd James Data Consultancy are on a mission to supply the very best consumer data, add value to existing data and deliver customer insight that drives performance and growth. Our solutions improves data quality and accuracy. With our data quality tools in place, we can drive efficiencies in contact whilst reducing wastage.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    To find out how Lloyd James could help unlock the power of your data, <Link to="/contact" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>click here to get in touch.</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataCleansingPage;